import { Container, Typography } from '@mui/joy';

const Error404Page = () => {
  
  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
      }}
    >
      
      <Typography level='h3' color='neutral' mb={1}>
        Oops! The page you're looking for isn't here.
      </Typography>
      <Typography level='body-lg'>
        You might have the wrong address, or the page may have moved.
      </Typography>
      
    </Container>
  );
};

export default Error404Page;
